import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { Dropdown, Overlay } from 'react-bootstrap';
import KTTooltip from '../OtherKeenComponents/KTTooltip';
import './style.scss';

VITableRowDropDown.propTypes = {
  menuItem: PropTypes.array,
  toggleElement: PropTypes.element,
  name: PropTypes.string,
  className: PropTypes.string,
  dropdownContent: PropTypes.element,
  singleBtnBgColor: PropTypes.string,
  keepOriginal: PropTypes.bool,
};

function VITableRowDropDown({
  menuItem,
  toggleElement,
  name,
  className,
  dropdownContent,
  singleBtnBgColor,
  keepOriginal = false,
}) {
  const [showMenu, setShowMenu] = useState(false);
  const dropdownRef = useRef(null);
  const refDropdownMenu = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current?.contains(event.target)) {
        if (!dropdownContent) {
          setShowMenu(false);
        } else if (!refDropdownMenu.current?.contains(event.target) && refDropdownMenu.current) {
          setShowMenu(false);
        }
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleToggle = () => {
    setShowMenu(!showMenu);
  };

  const handleClose = () => {
    setShowMenu(false);
  };

  const visibleItems = menuItem?.filter((item) => item?.show === undefined || item?.show) || [];
  const visibleCount = visibleItems.length;

  if (visibleCount === 0) {
    return null;
  }

  if (visibleCount === 1 && !keepOriginal) {
    const singleItem = visibleItems[0];
    return (
      <KTTooltip offset={[0, 0]} text={singleItem.text}>
        <a
          className={`btn btn-sm btn-clean btn-icon p-0 btn-table-action ${singleBtnBgColor ? 'h-45px w-45px' : ''
            }`}
          style={{
            backgroundColor: singleBtnBgColor,
          }}
          onClick={(e) => {
            e.preventDefault();
            if (!singleItem.disabled && singleItem.click) {
              singleItem.click();
            }
          }}
        >
          {singleItem.iconElement}
        </a>
      </KTTooltip>
    );
  }

  return (
    <Dropdown className="VITableRowDropDown" ref={dropdownRef}>
      <Dropdown.Toggle className={`border-0 p-0 ${className}`} variant="" onClick={handleToggle}>
        {toggleElement}
      </Dropdown.Toggle>

      <Overlay show={showMenu} placement="bottom" target={(ref) => ref && ref.parentElement}>
        {({ placement, arrowProps, show: _show, popper, ...props }) => (
          <div
            {...props}
            style={{
              position: 'absolute',
              zIndex: 1056,
              boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)',
              borderRadius: '4px',
              padding: '10px',
            }}
          >
            <Dropdown.Menu ref={refDropdownMenu} show={showMenu} className="w-auto">
              {dropdownContent ? (
                dropdownContent
              ) : (
                <div className="navi navi-bold navi-hover navi-active navi-link-rounded">
                  {menuItem.map((item, index) => {
                    return (
                      <div
                        className={`navi-item px-2`}
                        key={index}
                        onClick={(e) => {
                          if (item.disabled) {
                            e.preventDefault();
                            e.stopPropagation();
                          } else {
                            handleClose();
                            if (item.click) {
                              item.click();
                            }
                          }
                        }}
                      >
                        {item?.show === undefined || item?.show ? (
                          <a
                            href="#"
                            className="navi-link rounded-3 px-3"
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            <span className="navi-icon mr-1">
                              <span className="svg-icon">{item?.iconElement}</span>
                            </span>
                            <span
                              className={`navi-text font-size-lg me-3 ${item?.disabled ? 'disabled' : ''
                                }`}
                              style={{
                                whiteSpace: 'nowrap',
                                ...UIHelper.buildFontStyle('400', '14px', AppColors.gray[800]),
                              }}
                            >
                              {item?.text}
                            </span>
                          </a>
                        ) : (
                          <></>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </Dropdown.Menu>
          </div>
        )}
      </Overlay>
    </Dropdown>
  );
}

export default VITableRowDropDown;
